<netcard-modal
  [title]="'form-pages.update-data.title' | translate"
  [subtitle]="'form-pages.update-data.subtitle' | translate"
  [withoutActionButton]="true"
  size="sm"
  #updateDataModal
  >
  @if (initView()['UPDATE_IDENTITY_DOCUMENT']) {
    <div body class="px-4">
      <netcard-personal-information [updateDocumentOnly]="true" [startDisabled]="true" [showCancelButton]="true"></netcard-personal-information>
    </div>
  }
</netcard-modal>
